if (!customElements.get('component-afterpay-modal')) {
  customElements.define('component-afterpay-modal', class AfterpayModal extends HTMLElement {
    constructor() {
      super();

      this.afterpayModalButtonClose = this.querySelector('.js-afterpay-close');
      this.afterpayModalOverlay = this.querySelector('.modal__overlay');
  
      this.setEventListeners();
    }
  
    setEventListeners() {
      this.afterpayModalButtonClose.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent('hide-afterpay-modal'));
      });

      this.afterpayModalOverlay.addEventListener('click', () => {
        window.dispatchEvent(new CustomEvent('hide-afterpay-modal'));
      });

      window.addEventListener('show-afterpay-modal', () => {
        this.ariaHidden = false;
        this.classList.add('d-block');
      });

      window.addEventListener('hide-afterpay-modal', () => {
        this.ariaHidden = true;
        this.classList.remove('d-block');
      });
    }
  });
}
